import React from "react";
import { Dumbbell, ArrowRight, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StartNewWorkout() {
  return;
}